import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ReplaySubject, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class LanguageService {
    language$ = new ReplaySubject<LangChangeEvent>(1);
    translate = this.translateService;
    public lang: string;
    
    constructor(private translateService: TranslateService) {
    }

    setInitState() {
        this.translateService.addLangs(['en', 'zh-sc', 'zh-tc']);
        var browserLangStr = this.translate.getBrowserLang().toLowerCase();


        if (browserLangStr == "zh-cn" || browserLangStr == "zh-chs" || browserLangStr == "zh-sg") {
            browserLangStr = 'zh-sc';
        }
        else if (this.translate.getBrowserLang().includes('en')) {
            browserLangStr = 'en';
        }
        else
            browserLangStr = 'zh-tc';

        const browserLang = browserLangStr;
        this.setLang(browserLang);
    }

    setLang(lang: string) {
        this.translateService.onLangChange.pipe(take(1)).subscribe(result => {
            this.language$.next(result);
        });
        this.translateService.use(lang);
        this.lang = lang;
    }

    getLang() {
        return this.lang;
    }
}
